<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{ !data.sizeScaleId ? ('MENU.SIZE_SCALES.CREATE' | translate) : ('MENU.SIZE_SCALES.EDIT' | translate) }}
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field class="dish-name"  appearance="fill">
      <mat-label>{{ 'MENU.SIZE_SCALES.NAME' | translate }}</mat-label>
      <input matInput type="text" formControlName="sizeScaleName">
    </mat-form-field>

    <div *ngIf="data.organization.additionalLanguages">
      <mat-form-field class="dish-name" appearance="fill"
                      *ngFor="let lang of data.organization.additionalLanguages">
        <mat-label>{{ 'MENU.SIZE_SCALES.TRANSLATION' | translate }} {{ lang }}</mat-label>
        <input matInput type="text" formControlName="sizeScaleName{{lang}}">
      </mat-form-field>
    </div>

    <div>
      <mat-form-field>
        <mat-label>Visual type</mat-label>
        <mat-select formControlName="visualType">
          <mat-option  *ngFor="let visualType of visualTypes; index as i" [value]="visualType">{{visualType}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-bottom" style="display: flex">
      <button
        class="button"
        mat-button
        type="submit"
        (submit)="submit()"
        style="flex: auto"
      >{{ 'MENU.SAVE' | translate }}
      </button>

      <button
        *ngIf="data.sizeScaleId"
        mat-button
        type="button"
        (click)="remove()"
        style="flex: auto"
      >{{ 'MENU.DELETE' | translate }}
      </button>
    </div>
  </form>
</div>
